import React from 'react';
import './Journey.css';
import Schedule from './Schedule';

const Journey = () => (
  <section className="Journey">
    <div className="Journey__container">
      <h1 className="Journey__title">
        My Journey in Building Primed Landscaping and Finding Purpose
      </h1>

      <article className="Journey__section">
        <h2 className="Journey__heading">
          The Early Days: Nurturing the Entrepreneurial Spirit
        </h2>
        <p className="Journey__text">
          My journey as a business owner began long before Primed Landscaping
          came into existence. Growing up, I always had an entrepreneurial
          spirit. It all started with a summer lawn mowing business in my
          neighborhood. Even at a young age, I began learning the fundamentals
          of business, including how to manage and hire help—my neighbor was my
          first employee. When that summer ended, I continued doing small side
          jobs around the neighborhood. At sixteen, I took a job in fast food,
          only to quickly move on to a lifeguard position that offered a $4
          raise. Yet, the desire to work for myself persisted. After the
          summer, I took a job as a mover but left after four months due to
          grueling 60-hour weeks with no overtime pay.
        </p>
        <p className="Journey__text">
          During the brief period of free time that followed, I discovered a
          passion for photography. I dedicated two and a half months to
          perfecting my skills, both in capturing images and editing them. With
          careful savings, I had enough funds to start a media marketing
          business, "Rolling Web Media." Despite making a profit of around
          $4,000, the overwhelming responsibilities of handling legal matters,
          marketing, web design, and social media alone while still in school
          proved too much. I decided to shut down the business, but this
          experience taught me valuable lessons about entrepreneurship.
        </p>
      </article>

      <article className="Journey__section">
        <h2 className="Journey__heading">
          Finding Purpose and Partnership
        </h2>
        <p className="Journey__text">
          A pivotal moment came when I was helping my grandmother in her garden.
          The tranquility I found in working outdoors inspired me to extend my
          services to her neighbors and friends. This small endeavor quickly
          grew into a broader network of clients. As demand increased, I needed
          additional help and brought on my best friend, Joaquin Sheckler. This
          partnership was instrumental in scaling the business. Joaquin's
          support and shared commitment to the company's success made the hard
          work more manageable. We both invested our time, energy, and
          finances, and despite accumulating significant debt, our shared
          vision and dedication fueled the growth of the business.
        </p>
      </article>

      <article className="Journey__section">
        <h2 className="Journey__heading">
          Overcoming Challenges and Embracing Faith
        </h2>
        <p className="Journey__text">
          As young entrepreneurs, Joaquin and I made substantial sacrifices. I
          completed high school remotely to focus entirely on the business, a
          decision that was difficult but necessary for achieving our goals. Our
          hard work paid off as we established Primed Landscaping as a highly
          regarded home service company. We have earned a reputation for
          quality services and strive to offer the best prices in the area,
          making professional home services more accessible.
        </p>
        <p className="Journey__text">
          Throughout this journey, my faith in God and the salvation I found in
          Jesus Christ have been my guiding light. My spiritual beliefs have
          profoundly influenced my approach to business and life. I am deeply
          grateful for the path I have traveled and the opportunities that have
          come my way. I also want to express my heartfelt thanks to those who
          have supported me along the way—my parents for their unwavering
          encouragement, my grandmother for her inspiration, and everyone who
          has played a part in this journey. My aim now is to continue making a
          positive impact in our community by providing affordable home
          services and changing the perception of the home service industry for
          the better.
        </p>
      </article>
    </div>
    <Schedule/>
  </section>
);

export default Journey;